var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{ref:"upl",staticClass:"media-slot",attrs:{"for":"image_input_media"+_vm.unKey}},[_c('input',{ref:"inp",staticClass:"input_media",attrs:{"id":"image_input_media"+_vm.unKey,"type":"file","accept":"image/*"},on:{"change":function($event){return _vm.uploadImg($event)}}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }